module.exports = __webpack_public_path__ + "img/arrow-0.84496de3.png";